export { PLUGIN_KEY, PLUGIN_PRIORITY, CopyPaste } from "./copyPaste.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/copyPaste/index.mjs
// module id = 1324
// module chunks = 1